import React, { useEffect } from 'react';

import Domains from '@lcsc-ui/utils/domains';
import styled from 'styled-components';

const Content = styled.div`
  background: #fff;
`;
const ShareComponent = () => {
  useEffect(() => {
    if (!window.webSiteShareData) {
      window.webSiteShareData = {};
    }
    window.webSiteShareData.lcscStaticUrl = Domains.lcscStaticUrl;
    // 配置百度分享插件
    window._bd_share_config = {
      common: {
        bdSnsKey: {},
        bdDesc: '',
        bdComment: ' ',
        bdText: '',
        bdMini: '2',
        bdPic: '',
        bdStyle: '0',
        bdSize: '',
        bdUrl: '',
      },
      share: {},
    };
    // 动态加载百度分享插件的 JavaScript 文件
    const script = document.createElement('script');
    script.src = `${Domains.lcscStaticUrl}/static/api/js/share.js?v=89860593.js?cdnversion=${Math.floor(-new Date() / 36e5)}`;
    (document.getElementsByTagName('head')[0] || document.body).appendChild(script);
    // 清理脚本，防止内存泄漏
    return () => {
      document.head.removeChild(script);
      delete window._bd_share_config;
    };
  }, []);

  return (
    <Content>
      {/* 分享 1/2 - BEGIN */}
      <div className="bdsharebuttonbox" id="fxlogo">
        <a rel="nofollow" href="#" className="bds_more" data-cmd="more">
          分享到：
        </a>
        <a rel="nofollow" href="#" className="bds_weixin" data-cmd="weixin" title="分享到微信"></a>
        <a rel="nofollow" href="#" className="bds_tsina" data-cmd="tsina" title="分享到新浪微博"></a>
        <a rel="nofollow" href="#" className="bds_qzone" data-cmd="qzone" title="分享到QQ空间"></a>
        <a rel="nofollow" href="#" className="bds_sqq" data-cmd="sqq" title="分享到QQ好友"></a>
      </div>
      {/* 分享 1/2 - END */}
    </Content>
  );
};

export default ShareComponent;
